<template>
  <div v-if="!hbtFlowEnabled">
    <h2 class="fs-32 font-medium mb-8 spacer-standard-up" data-sticky-nav-item>
      Rooms
    </h2>
    <div class="mt-8">
      <ul class="list-reset">
        <li v-for="(room, index) in rooms" :key="index">
          <hr class="border border-black-30 my-8" v-if="index > 0" />
          <div class="flex sm:flex-wrap resort-room">
            <div class="flex-1 w-full h-full resort-room-image">
              <resort-image-carousel :images="room.images" :name="room.name" />
            </div>

            <div class="desc-section sm:border-none sm:px-0 sm:pb-0">
              <h4 class="fs-20 font-medium">{{ room.name }}</h4>
              <p
                class="mt-1 {% if room.inclusions | length == 0 %}flex-1{% endif %}"
              >
                {{ room.desc }}
              </p>

              <div class="text-black-light-5 mt-4 sm:mt-2 flex-1">
                {{ getShortenedInclusions(room) }}

                <div
                  class="text-secondary font-medium cursor-pointer mt-2"
                  @click="handleViewRoomInclusions(room)"
                >
                  View room details
                </div>
              </div>

              <div class="room-price text-right sm:text-left sm:my-6">
                <span>from</span>
                <currency-context>
                  <template v-slot="{ convert }">
                    <span
                      class="fs-20 font-medium"
                      v-text="convert(room.price)"
                    ></span>
                  </template>
                </currency-context>
                <span>/night</span>
              </div>
            </div>
          </div>
          <hr
            class="border border-black-30 my-8 sm:hidden"
            v-if="index + 1 === rooms.length"
          />
        </li>
      </ul>

      <zb-modal ref="moreModal" class="slide-in-modal">
        <h2 slot="title" class="fs-20 font-medium mb-6">Rooms facilities</h2>

        <template>
          <ul v-if="selectedRoom">
            <li v-for="(inclusions, group) in grouppedInclusions" :key="group">
              <h5 class="font-medium mb-4">
                {{ getGroupName(group) }}
              </h5>

              <div
                v-for="(item, itemIdx) in inclusions"
                :key="itemIdx"
                class="flex items-center h-12"
              >
                <div class="flex-none pr-3">
                  <template v-if="item.icon">
                    <img
                      width="28"
                      height="28"
                      :src="item.icon"
                      :alt="item.name"
                    />
                  </template>
                  <template v-else>
                    <div style="width: 28px">
                      <svg width="24" height="24">
                        <use xlink:href="/img/sprite.svg#ic_success"></use>
                      </svg>
                    </div>
                  </template>
                </div>
                <div class="flex-1">{{ item.name }}</div>
              </div>
            </li>
          </ul>
        </template>
      </zb-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import groupBy from "lodash/groupBy";
import { INCLUSION_TYPES } from "../../helpers/constants";
import ZbModal from "../core/ZbModal";
import ResortImageCarousel from "./ResortImageCarousel";
import CurrencyContext from "../core/CurrencyContext";

export default {
  components: {
    ZbModal,
    ResortImageCarousel,
    CurrencyContext,
  },
  props: ["resortId"],
  data() {
    return {
      rooms: [],
      selectedRoom: null,
    };
  },
  mounted() {
    window
      .fetchSupplierInfo(this.resortId)
      .then((res) => {
        this.rooms = res.rooms;
        if (!!res.supplier.hbt_flow_enabled) {
          $(".booking-widget-container").addClass("h-auto-important");
          $(".usp-content").addClass("hidden");
        }
      })
      .catch(() => {
        $(".resort-odyssey-rooms").addClass("hidden");
        $(".resort-original-rooms").removeClass("hidden");
      });
  },
  computed: {
    ...mapGetters(["hbtFlowEnabled"]),
    grouppedInclusions() {
      if (this.selectedRoom === null) {
        return {};
      }

      return groupBy(this.selectedRoom.inclusions, (incl) => incl.list_id);
    },
  },
  methods: {
    getShortenedInclusions(room) {
      const text = room.inclusions
        .map((inc) => inc.name)
        .slice(0, 3)
        .join(", ");

      if (room.inclusions.length > 3) {
        return text + "...";
      }
      return text;
    },
    handleViewRoomInclusions(room) {
      this.selectedRoom = room;
      this.$refs.moreModal.show();
    },
    getGroupName(groupListId) {
      return INCLUSION_TYPES[groupListId];
    },
  },
};
</script>

<style scoped>
.desc-section {
  padding: 1.5rem;
  flex: none;
  display: flex;
  flex-direction: column;
  width: 60%;
  border-left: none;
}

@media (max-width: 600px) {
  .desc-section {
    width: 100%;
    border: none;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }
}
</style>
